export default __webpack_public_path__ + "static/media/p_G-Logo-removebg-preview.615e639a.png";